export const routes = (parentName) => {
  return [
    {
      path: "transactions-courses",
      component: () => import("./Index.vue"),
      children: [
        {
          path: "",
          name: `${parentName}-TransactionsCourses`,
          component: () => import("./List.vue"),
          props: (route) => ({
            step: route.query.step,
          }),
        },

        {
          path: "gateway",
          name: `${parentName}-TransactionsCourses-Gateway`,
          component: () => import("./List.vue"),
          props: (route) => ({
            step: route.query.step,
          }),
        },
        {
          path: "new",
          name: `${parentName}-TransactionsCourses-New`,
          component: () => import("./Upsert.vue"),
        },
        {
          path: ":id",
          name: parentName + "-" + "TransactionsCourses-View",
          component: () => import("./View.vue"),
        },
        {
          path: ":id/edit",
          name: parentName + "-" + "TransactionsCourses-Edit",
          component: () => import("./Upsert.vue"),
        },
      ],
    },
  ];
};
